import { Fragment } from 'react';
import { Box } from '@nimbus-ds/components';
import { ErrorState } from '@tiendanube/components';
import { useToastStatus } from 'commons/hooks';
import { ChargesSelectionSummary } from 'domains/Billing/Checkout/pages/components';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { ChargeGroup, NoCharges } from './components';
import { useSelectCharges } from './hooks';
import SelectChargesToPayTabSkeleton from './Skeleton';

export default function SelectChargesToPayTab() {
  const t = useTranslationBilling(
    'checkout.plansAndSubscriptions.paymentsTabs.toPay',
  );

  const {
    retryLoad,
    chargeGroups,
    payOrderCreationStatus,
    isLoading,
    isError,
    selectedCharges,
  } = useSelectCharges(true);

  useToastStatus({
    status: payOrderCreationStatus,
    error: t('payOrderCreationFailed'),
  });

  if (isLoading) return <SelectChargesToPayTabSkeleton />;
  if (isError)
    return (
      <ErrorState
        title={t('error.title')}
        action={{ children: t('error.retry'), onClick: retryLoad }}
      />
    );

  if (!chargeGroups?.length) {
    return <NoCharges />;
  }

  return (
    <Box display="flex" flexDirection="column">
      {chargeGroups?.map((chargeGroup) => (
        <Fragment key={chargeGroup[0].id + '-group'}>
          <ChargeGroup charges={chargeGroup} />
          <hr />
        </Fragment>
      ))}
      <Box padding="4" backgroundColor="neutral-surface">
        <ChargesSelectionSummary
          currency={chargeGroups[0]?.[0]?.amountCurrency}
          charges={selectedCharges}
          showPeriodDiscounts
        />
      </Box>
    </Box>
  );
}
